import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=40f9155e&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDropdown: require('/app/components/admin/Header/HeaderDropdown.vue').default,Header: require('/app/components/admin/Header/Header.vue').default})
